export enum SessionTypeEnum {
    FORGOT_PASSWORD = 0,
    RESET_PASSWORD = 1,
    MFA = 2,
    VALIDATE = 3
}